var Header;
(function (Header) {
    myonce('header', () => {
        const $header = document.querySelector('#header');
        const $headerAffixer = document.querySelector('#header-affixer');
        let $imgIn = document.querySelector('#authIn');
        let $divLogNo = document.querySelector('.login-caller-no');
        let $divLogYes = document.querySelector('.login-caller-yes');
        let $logout = document.querySelector('#btn-logout');
        let $username = document.querySelector('#user_name');
        var imageMap = new Map();
        imageMap.set('35', ['/sites/default/files/2020-05/alleanza2x.jpg', 'Coop Alleanza 3.0']);
        imageMap.set('1', ['/sites/default/files/2020-05/novacoop2x.jpg', 'Coop Novacoop']);
        imageMap.set('2', ['/sites/default/files/2020-05/liguria2x.jpg', 'Coop Liguria']);
        imageMap.set('3', ['/sites/default/files/2020-05/lombardia2x.jpg', 'Coop Lombardia']);
        imageMap.set('7', ['/sites/default/files/2023-10/CoopFi_10ragioni.png', 'Unicoop Firenze']);
        imageMap.set('8', ['/sites/default/files/2025-06/Unicoop_Etruria.jpg', 'Unicoop Etruria']);
        imageMap.set('9', ['/sites/default/files/2020-05/centroitala2x.jpg', 'Coop centro Italia']);
        imageMap.set('15', ['/sites/default/files/2021-11/coop-reno.jpeg', 'Coop Reno']);
        imageMap.set('22', [
            '/sites/default/files/2021-12/coop-unione-amiatina-logo.png',
            'Coop Unione Amiatina',
        ]);
        imageMap.set('44', ['/sites/default/files/2021-12/doc-roma-logo.png', 'Doc Roma Srl']);
        imageMap.set('36', [
            '/sites/default/files/2021-12/coop-trentina-logo.jpg',
            'Cooperative Trentine',
        ]);
        imageMap.set('32', ['/sites/default/files/2020-05/tirreno2x.jpg', 'Distribuzione Roma']);
        if ($logout)
            $logout.addEventListener('click', logOut);
        if ($imgIn)
            $imgIn.addEventListener('click', handleClickLogin);
        checkLoggedIn();
        function moveMenu() {
            if (document.getElementsByClassName("nav-link dropdown-toggle show").length > 0 && document.getElementsByClassName("nav-link dropdown-toggle show")[0].getBoundingClientRect().x != document.getElementsByClassName("dropdown-menu show")[0].getBoundingClientRect().x) {
                var offset = (document.getElementsByClassName("nav-link dropdown-toggle show")[0].getBoundingClientRect().x - document.getElementsByClassName("dropdown-menu show")[0].getBoundingClientRect().x) - 15;
                if (offset > 30)
                    document.getElementsByClassName("dropdown-menu show")[0].style.left = offset + "px";
            }
        }
        if ($header && $headerAffixer) {
            const $body = document.querySelector('body');
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: [0.1],
            };
            let observer = new IntersectionObserver((entries, observer) => {
                const entry = entries.pop();
                if (entry.isIntersecting) {
                    $header.classList.remove('is-affixed');
                    $body.style.paddingTop = $header.offsetHeight;
                }
                else {
                    $header.classList.add('is-affixed');
                    $body.style.removeProperty('paddingTop');
                }
            }, options);
            observer.observe($headerAffixer);
            let observerMenu = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.target.classList.contains('show')) {
                        moveMenu();
                    }
                });
            });
            document.querySelectorAll(".dropdown-menu").forEach(el => {
                observerMenu.observe(el, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            });
        }
        function checkLoggedIn() {
            if (getCookie('session_token') != '') {
                parseCookies('session_info');
                $divLogNo.setAttribute('hidden', '');
                $divLogYes.removeAttribute('hidden');
                var result = imageMap.get(getCookie('session_coopId'));
            } 
        }
        function logOut() {
            delete_cookie('session_token');
            delete_cookie('session_email');
            delete_cookie('session_coopId');
            delete_cookie('session_info');
            delete_cookie('event_info');
            delete_cookie('aperitivo');
            $divLogNo.removeAttribute('hidden');
            $divLogYes.setAttribute('hidden', '');
            if (window.location.pathname == '/area-riservata/il-mio-profilo')
                window.location.href = '/auth/login';
        }
        function getCookie(cname) {
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }
        function delete_cookie(name) {
            if (getCookie(name) != '') {
                document.cookie =
                    name +
                        '=' +
                        ';domain=' +
                        window.location.hostname +
                        ';path=/' +
                        ';secure' +
                        ';expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
        }
        function handleClickLogin(event) {
            if (getCookie('session_token') == '') {
                window.location.href = '/auth/login';
            }
        }
        function parseCookies(cname) {
            let cookie = getCookie('session_info');
            const myArray = cookie.split('|');
            $username.innerHTML = myArray[3];
        }
    });
})(Header || (Header = {}));
